import { createContext } from 'react';
import type { ToastContextType } from '../lib/toast.types';

export const ToastContext = createContext<ToastContextType | null>(null);